import React, { FC } from "react";
import { PageHeaderProps } from "../../types";

const PageHeader: FC<PageHeaderProps> = ({ pageTitle }) => {
  return (
    <div className="text-black text-lg text-center font-bold tracking-tight pt-8 pb-5 ">
      {pageTitle}
    </div>
  );
};

export default PageHeader;
